<script setup lang="ts">
    import AppLayout from '@/layouts/AppLayout.vue';
    import PageCard from '@/components/PageCard.vue';
    import { Button } from '@/components/ui/button';
    import { Head } from '@inertiajs/vue3';
    import { computed } from 'vue';

    const canGoBack = computed(() => !!window.history.length);

    function goBack() {
        if (canGoBack.value) {

            window.history.back();
            return;
        }

        window.location.href = route('v2.index');
    }
    function goHome() {

        window.location.href = route('v2.index');
    }
</script>

<template>
    <Head title="404" />

    <AppLayout :hide-header="true">
        <PageCard class="flex min-h-[70vh] items-center justify-center bg-background p-0">
            <div class="flex w-full max-w-xl flex-col items-center gap-6 px-6 py-12 text-center">
                <div class="flex flex-col items-center text-secondary">
                    <span class="text-4xl font-semibold">404</span>
                    <span class="text-2xl font-medium">{{ $t('errors.404.title') ?? 'Not Found' }}</span>
                </div>
                <p class="text-muted-foreground">
                    {{ $t('errors.404.description') }}
                </p>
                <div class="flex flex-wrap justify-center gap-3">
                    <Button
                        v-if="canGoBack"
                        variant="outline"
                        @click="goBack"
                    >
                        {{ $t('forms.previous') }}
                    </Button>
                    <Button @click="goHome">
                        {{ $t('forms.home') ?? 'Go to dashboard' }}
                    </Button>
                </div>
            </div>
        </PageCard>
    </AppLayout>
</template>
